export default "__VITE_ASSET__PyTjnvDv__"